// Login único vindo de outro sistema do Gix (menu Apps → Gix Corporativo de outra empresa):
//   /users/sso_callback?jwt=<token do Gix>&redirect_url=<endereço>
// Guarda o token, tira-o da barra de endereço e do histórico, e segue para o endereço (só deste mesmo site).
// Roda antes de o React montar, então o JWTContext já começa com a sessão nova.
export function handleSsoCallback() {
  if (window.location.pathname.replace(/\/+$/, '') !== '/users/sso_callback') return;
  const q = new URLSearchParams(window.location.search);
  const jwt = q.get('jwt');
  let to = '/';
  try {
    const r = new URL(q.get('redirect_url') || '/', window.location.origin);
    if (r.origin === window.location.origin && !r.pathname.startsWith('/users/sso_callback')) to = r.pathname + r.search + r.hash;
  } catch (e) {
    // endereço inválido: vai para o início
  }
  if (jwt) {
    localStorage.setItem('serviceToken', jwt);
    localStorage.removeItem('user'); // o usuário é recarregado com a empresa nova
  }
  window.history.replaceState(null, '', to);
}
